export enum Environment {
  Sandbox = 'sandbox',
  Production = 'production',
}
